import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import MailOutline from "@material-ui/icons/MailOutline";
import { Redirect, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import { bookingApi } from "functions/apis";
import AnnouncementForm from "./AnnouncementForm";
import {
  confirmContentImages,
  emptyAnnouncement,
  toAnnouncementInput
} from "./AnnouncementShared";

const useStyles = makeStyles(styles);

const EditAnnouncement = props => {
  const classes = useStyles();
  const { id } = useParams();
  const [redirect, setRedirect] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [input, setInput] = useState(emptyAnnouncement);
  const [ready, setReady] = useState(false);

  const signal = useRef(new AbortController());

  useEffect(() => {
    bookingApi
      .get("Announcements/" + id, { signal: signal.current.signal })
      .then(data => {
        setInput(toAnnouncementInput(data));
        setReady(true);
        setDisabled(false);
      })
      .catch(error => console.log(error));
    return () => signal.current.abort();
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    setDisabled(true);
    if (!(await confirmContentImages(input.contentHtml))) {
      setDisabled(false);
      return;
    }
    bookingApi
      .put("Announcements/" + id, input, { signal: signal.current.signal })
      .then(() => {
        Swal.fire({
          title: "Success!",
          text: "Announcement updated.",
          icon: "success",
          didClose: () => setRedirect(true)
        });
      })
      .catch(error => {
        if (signal.current.signal.aborted) return;
        console.log(error);
        setDisabled(false);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/Announcement/List"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>EDIT ANNOUNCEMENT</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <AnnouncementForm
              input={input}
              setInput={setInput}
              disabled={disabled}
              onSubmit={handleSubmit}
              ready={ready}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default EditAnnouncement;

EditAnnouncement.propTypes = {
  history: PropTypes.object
};
